export default "__VITE_ASSET__BA7i2kwj__"